/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Google_Synced_HintInputs */

const cs_auth_google_synced_hint = /** @type {(inputs: Auth_Google_Synced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pro tento e-mail lze použít přihlášení přes Google.`)
};

const en_auth_google_synced_hint = /** @type {(inputs: Auth_Google_Synced_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Google sign-in is available for this email.`)
};

/**
* | output |
* | --- |
* | "Google sign-in is available for this email." |
*
* @param {Auth_Google_Synced_HintInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const auth_google_synced_hint = /** @type {((inputs?: Auth_Google_Synced_HintInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Google_Synced_HintInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_auth_google_synced_hint(inputs)
	return cs_auth_google_synced_hint(inputs)
});